import EditIcon from '@mui/icons-material/Edit'
import { AppBar, Toolbar, Button, Box, Typography, styled } from '@mui/material'
import MultiDocNav from 'components/DocumentDetail/MultiDocNav'
import OverflowText from 'components/ui/OverflowText'
import StatusBadge from 'components/ui/StatusBadge'
import { Document } from 'entities/Documents'
import { useLocation, useNavigate } from 'react-router-dom'

const EditButton = styled(EditIcon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontSize: '1em',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}))

interface Props {
  docDetail: Document
  objIDs: string[] | null
  currentIdx: number
  setOIdx: (idx: number) => void
  onSave: () => void
  onSend: () => void
  onDownload: () => void
  setOpenDelDialog: (x: boolean) => void
  openRenameDialog: () => void
  renamedName?: string
}

function Header({
  objIDs,
  currentIdx,
  setOIdx,
  docDetail,
  onSave,
  onSend,
  onDownload,
  setOpenDelDialog,
  openRenameDialog,
  renamedName,
}: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const { documentStatusNo, documentName } = docDetail.docInfo

  const openDelDocDialog = () => {
    setOpenDelDialog(true)
  }

  const backToHome = () => {
    if (location.state?.fromIndexPage) {
      navigate(-1)
    } else {
      navigate('../home')
    }
  }

  return (
    <AppBar position="absolute" sx={{ color: 'text.primary', backgroundColor: 'common.white' }}>
      <Toolbar>
        <MultiDocNav objIDs={objIDs} currentIdx={currentIdx} setOIdx={setOIdx} />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginRight: 'auto',
          }}
        >
          <StatusBadge status={documentStatusNo} sx={{ mr: 2 }} />
          <Typography
            variant="h2"
            style={{
              fontWeight: 'normal',
              fontSize: '1rem',
              maxWidth: '40vw',
            }}
          >
            <OverflowText>{renamedName || documentName}</OverflowText>
          </Typography>
          <EditButton onClick={openRenameDialog} data-testid="rename" />
        </Box>
        <Box sx={{ flexShrink: 0, ml: 2 }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={backToHome}
            data-testid="document-detail-back-to-documents-list-button"
          >
            一覧に戻る
          </Button>
          {docDetail.canSave() && (
            <Button variant="outlined" onClick={onSave} data-testid="document-detail-save-button">
              一時保存
            </Button>
          )}
          <Button
            variant="contained"
            onClick={() => onDownload()}
            data-testid="document-detail-download-results-button"
          >
            {docDetail.canSave() && '一時保存&'}結果のダウンロード
          </Button>
          {docDetail.canSend() && (
            <Button
              disableElevation
              variant="contained"
              onClick={onSend}
              data-testid="document-detail-send-results-button"
            >
              結果の送信
            </Button>
          )}
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            onClick={openDelDocDialog}
            data-testid="document-detail-delete-button"
          >
            削除
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Header
